const website = window.location.protocol + '//' + window.location.hostname + (window.location.port === '' ? '' : ':' + 8000);

export const environment = {
   production: true,
   hmr: false,
   website,
   endpoint: '/api/'
};
